import {SimplePresentation, SimplePresentationRunnerController} from "../../SimplePresentationRunner";
import {gsap} from "gsap";
import {XwaysHoarder2} from "../../XwaysHoarder2";
import {SymbolStates} from "../../reels/symbols/BasicSymbol";
import {XWaySymbol} from "../../reels/symbols/XWaySymbol";
import {XwaysHoarder2Statics} from "../../XwaysHoarder2Statics";
import {SpineGSAPWrapper} from "../../utils/SpineGSAPWrapper";
import {XwaysHoarder2GameAssets} from "../../XwaysHoarder2GameAssets";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {XwaysHoarder2Sound} from "../../sound/XwaysHoarder2Sound";


export class XWaysMergePresentation implements SimplePresentation {
    name: string = "XWaysMergePresentation";
    private _mergeTl: gsap.core.Timeline;

    shouldRun(): boolean {
        return XwaysHoarder2.model.xwMerge.includes(true);
    }

    start(controller: SimplePresentationRunnerController): void {
        this._mergeTl = gsap.timeline({
            onComplete: () => {
                controller.setSkipCallback();
                controller.finish();
            }
        });


        let mergeSoundPlayed: boolean = false;
        XwaysHoarder2.model.xwMerge.forEach((toMerge: boolean, reelNo: number) => {
            if (toMerge) { //merge happens and keep the topmost XW sym in reel

                //special case handlinf for respin merges
                if (XwaysHoarder2.model.gameData.mode === GameMode.RESPIN) {
                    XwaysHoarder2.reelView.reels[reelNo].model.moveStickyXWBack();
                    XwaysHoarder2.reelView.reels[reelNo].model.xwaysArray = [];
                }


                let xwSymId: number = -1;
                XwaysHoarder2.model.firstXWPerReelPos.forEach((xwPos: number[]) => {
                    if (xwPos[0] === reelNo) {
                        xwSymId = xwPos[1];
                    }
                });
                const xwSymToStay: XWaySymbol = <XWaySymbol>XwaysHoarder2.reelView.reels[reelNo].model.getVisibleSymbolAt(xwSymId).positionable;
                let nextSymId: number = -1;
                for (let i: number = xwSymId + 1; i < 3; i++) {
                    if (XwaysHoarder2.reelView.reels[reelNo].model.getVisibleSymbolAt(i).name === "XW") {
                        nextSymId = i;
                        break;
                    }
                }

                const xwSymToRmv: XWaySymbol = <XWaySymbol>XwaysHoarder2.reelView.reels[reelNo].model.getVisibleSymbolAt(nextSymId).positionable;

                const oneReelMergeTl: gsap.core.Timeline = gsap.timeline();
                const finalHeightForXWtoStay: number = xwSymToStay.symbolHeight + xwSymToRmv.symbolHeight;

                const xwMergeSpine: PIXI.spine.Spine = new PIXI.spine.Spine(XwaysHoarder2.assetLoader.getSpineAsset(XwaysHoarder2GameAssets.XW_MERGE));
                xwMergeSpine.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, xwSymToStay.symID * 200 + xwSymToStay.visualHeightStatus * 0.5 + 200);
                xwMergeSpine.alpha = 0;
                XwaysHoarder2.reelView.reels[reelNo].layers.overlay.addChild(xwMergeSpine);

                // check for respin if state is sticky
                if (xwSymToStay.state === SymbolStates.STICKY) {
                    oneReelMergeTl.add(xwSymToStay.getStateAnimation(SymbolStates.UNSTICKY), 0);
                }
                if (xwSymToRmv.state === SymbolStates.STICKY) {
                    oneReelMergeTl.add(xwSymToRmv.getStateAnimation(SymbolStates.UNSTICKY), 0);
                }
                oneReelMergeTl.addLabel("mergeStart");

                oneReelMergeTl.to(xwMergeSpine, {alpha: 1, duration: 0.001}, "mergeStart");
                oneReelMergeTl.to([xwSymToRmv.view, xwSymToStay.view], {alpha: 0, duration: 0.001}, "mergeStart");
                if (xwSymToStay.symbolHeight === 1 && xwSymToRmv.symbolHeight === 1) {
                    oneReelMergeTl.add(SpineGSAPWrapper.createTimelineForAnimation(xwMergeSpine, 0, "1+1", false), "mergeStart");
                } else if (xwSymToStay.symbolHeight === 1 && xwSymToRmv.symbolHeight === 2) {
                    xwMergeSpine.position.y += 100;
                    oneReelMergeTl.add(SpineGSAPWrapper.createTimelineForAnimation(xwMergeSpine, 0, "2+1", false), "mergeStart");
                } else if (xwSymToStay.symbolHeight === 2 && xwSymToRmv.symbolHeight === 1) {
                    xwMergeSpine.position.y += 100;
                    oneReelMergeTl.add(SpineGSAPWrapper.createTimelineForAnimation(xwMergeSpine, 0, "1+2", false), "mergeStart");
                }

                if(!mergeSoundPlayed) {
                    oneReelMergeTl.add(() => {
                        XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.XWAY_CONNECTS);
                    }, "<");
                    mergeSoundPlayed = true;
                }
                oneReelMergeTl.add(xwSymToStay.mergeEndAnimation(finalHeightForXWtoStay),SpineGSAPWrapper.animationTimeDuration(xwMergeSpine,"1+1"));
                xwSymToStay.isOldSym = false;
                oneReelMergeTl.to(xwSymToStay.view, {
                    alpha: 1,
                    duration: 0.001
                },SpineGSAPWrapper.animationTimeDuration(xwMergeSpine, "1+1"));
                oneReelMergeTl.add(() => {
                    XwaysHoarder2.reelView.reels[reelNo].layers.overlay.removeChild(xwMergeSpine);
                    XwaysHoarder2.reelView.reels[reelNo].replaceSymOnReel(xwSymToRmv.symID, "D");
                });
                this._mergeTl.add(oneReelMergeTl, 0);
            }
        });

        controller.setSkipCallback(() => this.onMergeSkip());


    }

    private onMergeSkip(): void {
        this._mergeTl.totalProgress(1);
    }
}